"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
// This utilities class serves functions common to feedback directives, services, controller.
/**
 * Copies the line from startWordNumber to lastWordNumber.
 * 1. If startWordNumber and lastWordNumber are null, entire line is copied
 * 2. If startWordNumber is null and lastWordNumber is not null, text is copied from the start of the line till the lastWordNumber
 * 3. If startWordNumber is not null but lastWordNumber is null, text is copied from the startWordNumber until end of the line
 */
function copyLine(annotationIndex, wordSeparator, pageIndex, lineIdx, startWordNumber, lastWordNumber) {
    if (wordSeparator === null || pageIndex === null || lineIdx === null) {
        console.error("Invalid inputs to copyLine. wordSeparator=" + wordSeparator +
            "; pageIndex=" + pageIndex + "; lineIdx=" + lineIdx);
        return;
    }
    var page = annotationIndex[pageIndex] || annotationIndex.pages[pageIndex];
    if (page === undefined) {
        console.error("Page not found. wordSeparator=" + wordSeparator +
            "; pageIndex=" + pageIndex + "; lineIdx=" + lineIdx);
        return;
    }
    var line = page.lines[lineIdx];
    if (line === undefined) {
        console.error("Line not found. wordSeparator=" + wordSeparator +
            "; pageIndex=" + pageIndex + "; lineIdx=" + lineIdx);
        return;
    }
    var wordObjsToCopy, wordsToCopy;
    var lastWordIdx, startWordIdx;
    if (lastWordNumber === null || lastWordNumber === undefined) {
        lastWordIdx = line.words.length - 1;
    }
    else {
        lastWordIdx = _.findIndex(line.words, { num: lastWordNumber });
    }
    if (startWordNumber === null || lastWordNumber === undefined) {
        startWordIdx = 0;
    }
    else {
        startWordIdx = _.findIndex(line.words, { num: startWordNumber });
    }
    if (startWordIdx === -1 || lastWordIdx === -1) {
        console.error("word number not found. wordSeparator=" + wordSeparator +
            "; pageIndex=" + pageIndex + "; lineIdx=" + lineIdx + "; startWordNumber=" + startWordNumber + "; lastWordNumber=" + lastWordNumber);
        return '';
    }
    if (lastWordIdx < startWordIdx) {
        console.error("lastWordIdx < startWordIdx.");
        return '';
    }
    //We need to add 1 to the lastWordIdx because slice drops the last item
    wordObjsToCopy = line.words.slice(startWordIdx, lastWordIdx + 1);
    wordsToCopy = wordObjsToCopy.map(function (word) {
        return word.text;
    });
    return (wordsToCopy.join(wordSeparator));
}
;
function getLinesInSelection(annotationIndex, pageNumber, startLineNumber, startWordNumber, endLineNumber, endWordNumber) {
    if (pageNumber === null || startLineNumber === null || startWordNumber === null ||
        endLineNumber === null || endWordNumber === null ||
        startLineNumber > endLineNumber || startWordNumber > endWordNumber) {
        console.error("Invalid inputs to annotationUtilities.getLinesInSelection. " +
            "pageNumber=" + pageNumber +
            "; startLineNumber=" + startLineNumber +
            "; startWordNumber=" + startWordNumber +
            "; endLineNumber=" + endLineNumber +
            "; endWordNumber=" + endWordNumber);
        return;
    }
    var pageIndex = pageNumber - 1, lineIterator, linesToCopy = [], separator = (annotationIndex.trueFormat ? "" : " ");
    if (startLineNumber === endLineNumber) {
        linesToCopy.push(copyLine(annotationIndex, separator, pageIndex, startLineNumber, startWordNumber, endWordNumber));
    }
    else {
        linesToCopy.push(copyLine(annotationIndex, separator, pageIndex, startLineNumber, startWordNumber, null));
    }
    for (lineIterator = startLineNumber + 1; lineIterator < endLineNumber; lineIterator++) {
        linesToCopy.push(copyLine(annotationIndex, separator, pageIndex, lineIterator, null, null)); //Must pass NULLs
    }
    if (startLineNumber !== endLineNumber) {
        linesToCopy.push(copyLine(annotationIndex, separator, pageIndex, lineIterator, null, endWordNumber));
    }
    return linesToCopy;
}
;
var annotationUtilities = {
    copyLine: copyLine,
    getLinesInSelection: getLinesInSelection
};
exports.default = annotationUtilities;
